import React from 'react';

import PropTypes from 'prop-types';


import './TextBoxInput.css';

const TextBoxInputC = (props) => {

  return (
    <div className='textbox-input-wrapper'>
      <input
        value={props.value}
        onChange={(e) => props.updateValue(e, props.inputIdentifier)}
        placeholder={props.placeholder}
        className={`input-element ${(!props.isValid && props.isTouched) ? 'input-element-invalid' : ''}`}
        {...props.config}
        automationid={`SalesLead_Input_${props.automationidattr}Input_0`}
      />
      {
        (!props.isValid && props.isTouched) ?
          <span className="invalid-msg" automationid={`SalesLead_Span_${props.automationidattr}Error_0`} >{props.validations.invalidMessage}</span>
          :
          null
      }
    </div>
  )
};

TextBoxInputC.propTypes = {
  automationidattr: PropTypes.string,
  config: PropTypes.any,
  inputIdentifier: PropTypes.any,
  isTouched: PropTypes.bool,
  isValid: PropTypes.bool,
  placeholder: PropTypes.string,
  updateValue: PropTypes.func.isRequired,
  validations: PropTypes.object,
  value: PropTypes.string.isRequired,
}

TextBoxInputC.defaultProps = {
  isValid: true,
}

const TextBoxInput = TextBoxInputC;

export default TextBoxInput;
